import { takeLatest, put, call, select } from 'redux-saga/effects'
import {
  INIT_LOYALTY_DATA,
  CREATE_LOYALTY,
  EDIT_LOYALTY,
  RESET_LOYALTY,
  DEACTIVATE_LOYALTY,
  REACTIVATE_LOYALTY
} from 'actions/customers/loyalty/constants'

import * as action from 'actions'
import * as actNotif from 'actions/notifications'
import * as loyaltyAction from 'actions/customers/loyalty'
import * as api from 'api/customers/loyalty'
import { endTutorial } from 'api/feature/endTutorial'
import * as mpLoyalty from 'mixpanel/customers/loyalty'

export const getBusinessId = state => state.moka.user.business.id

export function * initLoyaltyDataFlow () {
  let payload
  try {
    yield put(action.sendingRequest(true))
    yield put(action.showProgressBar())
    let businessId = yield select(getBusinessId)
    let response = yield call(api.getLoyalty, businessId)
    payload = response.data
    payload.hasLoyalty = true
  } catch (error) {
    payload = {hasLoyalty: false}
  } finally {
    yield put(loyaltyAction.setLoyalty(payload))
    yield put(action.sendingRequest(false))
    yield put(action.hideProgressBar())
  }
}

export function * createLoyaltyFlow (request) {
  let data = request.payload
  let payload
  try {
    yield put(action.sendingRequest(true))
    yield put(action.showProgressBar())
    let businessId = yield select(getBusinessId)
    yield call(api.createLoyalty, businessId, data)
    let response = yield call(api.getLoyalty, businessId)
    payload = response.data
    payload.hasLoyalty = true
    yield call(api.addSubscription)
    yield call(endTutorial, {feature_name: 'Loyalty'})
    yield put(loyaltyAction.setLoyalty(payload))
    yield call(mpLoyalty.createLoyaltySuccess)
  } catch (error) {
    const displayErrorMessage = 'Internal server error. Please try again later.'

    yield call(mpLoyalty.createLoyaltyFail, displayErrorMessage, error)
    yield put(actNotif.error(displayErrorMessage))
  } finally {
    yield put(action.sendingRequest(false))
    yield put(action.hideProgressBar())
  }
}

export function * editLoyaltyFlow (request) {
  let data = request.payload
  let payload
  try {
    yield put(action.sendingRequest(true))
    yield put(action.showLoadingSpinner(true))
    let businessId = yield select(getBusinessId)
    yield call(api.editLoyalty, businessId, data)
    let response = yield call(api.getLoyalty, businessId)
    payload = response.data
    yield put(loyaltyAction.setLoyalty(payload))
    yield put(actNotif.success('Loyalty program is saved successfully.'))
  } catch (error) {
    yield put(actNotif.error('Internal server error. Please try again later.'))
  } finally {
    yield put(action.sendingRequest(false))
    yield put(action.showLoadingSpinner(false))
  }
}

export function * resetLoyaltyFlow (request) {
  let data = request.payload
  let payload
  try {
    yield put(action.sendingRequest(true))
    yield put(action.showLoadingSpinner(true))
    let businessId = yield select(getBusinessId)
    yield call(api.resetLoyalty, businessId, data)
    let response = yield call(api.getLoyalty, businessId)
    payload = response.data
    yield put(loyaltyAction.setLoyalty(payload))
    yield put(actNotif.success('Loyalty program is saved successfully.'))
  } catch (error) {
    yield put(actNotif.error('Internal server error. Please try again later.'))
  } finally {
    yield put(action.sendingRequest(false))
    yield put(action.showLoadingSpinner(false))
  }
}

export function * deactivateLoyaltyFlow () {
  let payload
  try {
    yield put(action.sendingRequest(true))
    yield put(action.showLoadingSpinner(true))
    let businessId = yield select(getBusinessId)
    yield call(api.deactivateLoyalty, businessId)
    let response = yield call(api.getLoyalty, businessId)
    payload = response.data
    yield put(loyaltyAction.setLoyalty(payload))
    yield put(actNotif.success('Loyalty program is saved successfully.'))
  } catch (error) {
    yield put(actNotif.error('Internal server error. Please try again later.'))
  } finally {
    yield put(action.sendingRequest(false))
    yield put(action.showLoadingSpinner(false))
  }
}

export function * reactivateLoyaltyFlow (request) {
  let data = request.payload
  let payload
  try {
    yield put(action.sendingRequest(true))
    yield put(action.showLoadingSpinner(true))
    let businessId = yield select(getBusinessId)
    yield call(api.reactivateLoyalty, businessId, data)
    let response = yield call(api.getLoyalty, businessId)
    payload = response.data
    yield put(loyaltyAction.setLoyalty(payload))
    yield put(actNotif.success('Loyalty program is saved successfully.'))
  } catch (error) {
    yield put(actNotif.error('Internal server error. Please try again later.'))
  } finally {
    yield put(action.sendingRequest(false))
    yield put(action.showLoadingSpinner(false))
  }
}

export default function * customersLoyaltySaga () {
  yield takeLatest(INIT_LOYALTY_DATA, initLoyaltyDataFlow)
  yield takeLatest(CREATE_LOYALTY, createLoyaltyFlow)
  yield takeLatest(EDIT_LOYALTY, editLoyaltyFlow)
  yield takeLatest(RESET_LOYALTY, resetLoyaltyFlow)
  yield takeLatest(DEACTIVATE_LOYALTY, deactivateLoyaltyFlow)
  yield takeLatest(REACTIVATE_LOYALTY, reactivateLoyaltyFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/customers/loyalty.js